import styled from 'styled-components';

import Button from '@style-guide/components/Button';

const MobileButton = styled(Button)``;

MobileButton.displayName = 'MobileButton';

export default MobileButton;
